<script>
  import { onMount, tick, createEventDispatcher } from 'svelte';
  import { browser } from '$app/environment';
  import { getGroupStore } from '@stores/group';

  let recsStore = getGroupStore('recsStore');
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');

  import RecAjax from '@ajax/rec';
  import SectionAjax from '@ajax/section';
  import BrowserUtils from '@utils/browser-utils';
  import ComponentEvents from '@utils/component-events';
  import ScrollSpy from '@utils/scrollspy';
  import Notification from '@utils/notification';

  import SectionTile from './SectionTile.svelte';
  import BackToTop from './BackToTop.svelte';
  import Sortable from 'sortablejs';
  import queryString from 'query-string';

  const AutoScroll = Sortable.AutoScroll;

  try {
    Sortable.mount(new AutoScroll());
  } catch {}

  let sticky = false;

  const dispatch = createEventDispatcher();
  const scrollPositionBeforeSticky = 335;
  import jQuery from 'jquery';

  let group = groupStore;
  let sections = sectionsStore;
  let recs = recsStore;
  let sectionsMap = {};
  let unsubGroup = groupStore.subscribe((x) => (group = x));
  let unsubRecs = recsStore.subscribe((x) => (recs = x));
  let unsubSections = sectionsStore.subscribe((x) => {
    sections = x;
    sectionsMap = {};

    sections
      .sortBy((x) => x.position)
      .forEach((s, i) => {
        sectionsMap[s.id] = { i };
      });
  });

  let selectedSectionId;
  let addingSection = false;
  let showAll = false;
  let sorting = false;
  let recObjectSorting = false;
  let shownStart = 0;
  export let maxShown = 6;

  let sectionBarEl;
  let sectionBarElHeight = 0;

  let scrollDirection;
  let scrollUpdatesEnabled = true;
  let hoverOnDraggingRecObjectTimeout;

  let refresh = 1;
  let queryParams = browser && queryString.parse(location.search);

  $: {
    if (selectedSectionId && sectionsMap[selectedSectionId]) {
      let currentSectionIndex = sectionsMap[selectedSectionId].i;

      if (
        sections.length > maxShown &&
        sections.length > currentSectionIndex + 1 &&
        currentSectionIndex + 2 >= maxShown
      ) {
        shownStart = currentSectionIndex + 2 - maxShown;
      }
      if (currentSectionIndex + 1 < maxShown) {
        shownStart = 0;
      }
    }
  }

  $: hideSections = queryParams && queryParams['show_sections'] === 'false' && sections.length == 0 && recs.length < 3;

  let computeSectionElHeight = async function () {
    if (sectionBarEl) {
      await tick();
      sectionBarElHeight = sectionBarEl.offsetHeight;
    }
  };

  let addSection = async function () {
    addingSection = true;

    try {
      let resp = await SectionAjax.create(group, {
        name: 'New Section',
      });

      ComponentEvents.trigger('section-bar-keep-visibility', {
        fn: async () => {
          showAll = true;

          if (sectionsStore.length == 0) {
            recsStore.set(await RecAjax.fetch(group)); // a new section puts rec objects in "other" section. We need to retrieve the recs again
            sectionsStore.set(await SectionAjax.fetch(group));
          } else {
            sectionsStore.add(resp);
          }

          await tick();

          let elem = jQuery(`[data-section-bar-section-id="${resp.id}"]`).find('.editable-content')[0];

          if (elem) {
            BrowserUtils.focusAndHighlight(elem);

            let range = document.createRange();
            range.selectNodeContents(elem);
            let sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          }

          computeSectionElHeight();
        },
      });
    } catch {}

    addingSection = false;
  };

  let goToSection = async function (section) {
    showAll = false;
    await computeSectionElHeight();

    try {
      document.getSelection().removeAllRanges();
    } catch {}

    ComponentEvents.trigger('section-bar-show', {
      section: section,
      fn: async function () {
        await BrowserUtils.goToElementWithScroll(jQuery(`#grid-section-${section.id}`)[0], {
          offsetTop: (sectionBarElHeight + 100) * -1,
        });

        selectedSectionId = section.id;
      },
    });
  };

  let monitorScrollPosition = function () {
    let previousScrollPosition;
    jQuery(window).on('scroll', function () {
      let top = jQuery(window).scrollTop();
      let newscrollDirection;

      if (scrollUpdatesEnabled) {
        newscrollDirection = previousScrollPosition < top ? 'down' : 'up';

        let prevSticky = !!sticky;
        if (newscrollDirection === 'up') {
          sticky = top >= scrollPositionBeforeSticky;
        } else {
          sticky = top >= scrollPositionBeforeSticky + jQuery(sectionBarEl).outerHeight();

          if (prevSticky === false && sticky === true) {
            showAll = false;
            computeSectionElHeight();
          }
        }
        if (prevSticky !== sticky || newscrollDirection != scrollDirection) {
          dispatch('sticky-changed', { sticky: sticky, scrollDirection: newscrollDirection });
        }
        scrollDirection = newscrollDirection;
      }

      previousScrollPosition = top;
    });
  };

  let updateSectionOrder = async function (ids) {
    try {
      await SectionAjax.changeSortOrder(group, ids);
    } catch (err) {
      if (err && err.error && err.error != '') {
        Notification.send({ text: err.error });
      }

      refresh += 1;
      return;
    }

    sectionsStore.forEach((s) => {
      s.position = ids.indexOf(s.id) + 1;
    });

    sectionsStore.runCallbacks();
    ComponentEvents.trigger('refresh-broken-owl');
  };

  let setupSortable = function (node) {
    if (group && group.permissions && group.permissions.edit) {
      new Sortable(node, {
        scroll: true,
        dragClass: 'section-bar-sortable-dragging-item',
        onStart: (evt) => {
          scrollUpdatesEnabled = false;
          sorting = true;
          jQuery(evt.item).children('.section-bar-single-section').hide();
          jQuery(evt.item).children('.draggable-placeholder').show();
          computeSectionElHeight();
        },
        onSort: (_evt) => {
          var ids = [];
          jQuery(node)
            .children('[data-section-bar-section-id]')
            .each(function () {
              ids.push(jQuery(this).data('section-bar-section-id'));
            });

          updateSectionOrder(ids);
        },
        onEnd: (evt) => {
          jQuery(evt.item).children('.section-bar-single-section').show();
          jQuery(evt.item).children('.draggable-placeholder').hide();
          sorting = false;
          scrollUpdatesEnabled = true;
          computeSectionElHeight();
        },
      });
    }
  };

  let handleScrollUpdateOptions = async function (data) {
    if (data.shown !== undefined) {
      scrollDirection = data.shown ? 'up' : 'down';
    }

    if (data.showAll !== undefined) {
      if (data.showAll === 'ifNotSticky') {
        showAll = !sticky;
      } else {
        showAll = data.showAll;
      }
    }

    if (data.recObjectSorting !== undefined) {
      recObjectSorting = data.recObjectSorting;
    }

    await tick();
    computeSectionElHeight();
  };

  let unsubDisableScrollUpdates = ComponentEvents.on('section-bar-disable-scroll-updates', async (data) => {
    await handleScrollUpdateOptions(data);
    scrollUpdatesEnabled = false;
  });

  let unsubEnableScrollUpdates = ComponentEvents.on('section-bar-enable-scroll-updates', async (data) => {
    await handleScrollUpdateOptions(data);
    scrollUpdatesEnabled = true;
  });

  let enableHoverDuringRecObjectDrag = function () {
    if (hoverOnDraggingRecObjectTimeout) {
      clearTimeout(hoverOnDraggingRecObjectTimeout);
    }

    if (recObjectSorting) {
      hoverOnDraggingRecObjectTimeout = setTimeout(() => {
        showAll = true;
      }, 500);
    }
  };

  let disableHoverDuringRecObjectDrag = function () {
    if (hoverOnDraggingRecObjectTimeout) {
      clearTimeout(hoverOnDraggingRecObjectTimeout);

      if (recObjectSorting) {
        showAll = false;
      }
    }
  };

  let unsubKeepVisbilityEvent = ComponentEvents.on('section-bar-keep-visibility', async function (data) {
    scrollUpdatesEnabled = false;
    await data.fn();
    await tick();

    setTimeout(function () {
      scrollUpdatesEnabled = true;
    }, 500);
  });

  let unsubShowSectionBarEvent = ComponentEvents.on('section-bar-show', async function (data) {
    sticky = true;
    scrollDirection = 'up';
    scrollUpdatesEnabled = false;

    await data.fn();
    await tick();

    setTimeout(function () {
      scrollUpdatesEnabled = true;
    }, 500);
  });

  let removeScrollSpy;
  const setupScrollSpy = () => {
    ScrollSpy.setup('grid-current-section');
    removeScrollSpy = ScrollSpy.on('grid-current-section', (data) => {
      ComponentEvents.trigger('current-section', data);
    });
  };

  let unsubCurrentSectionComponentEvent;
  const setupCurrentSectionComponentEvent = () => {
    unsubCurrentSectionComponentEvent = ComponentEvents.on('current-section', async (data) => {
      if (scrollUpdatesEnabled && data && data.section) {
        selectedSectionId = data.section.id;
      }
    });
  };

  onMount(() => {
    monitorScrollPosition();
    computeSectionElHeight();
    setupScrollSpy();
    setupCurrentSectionComponentEvent();

    return () => {
      unsubGroup();
      unsubRecs && unsubRecs();
      unsubSections();
      unsubKeepVisbilityEvent();
      unsubShowSectionBarEvent();
      unsubDisableScrollUpdates();
      unsubEnableScrollUpdates();
      removeScrollSpy();
      jQuery(window).off(`resize.grid.section-bar`);
      unsubCurrentSectionComponentEvent();
    };
  });
</script>

<style style="text/scss" lang="scss">
  .grid-sections-bar {
    width: 100%;
    top: 64px;
    padding-bottom: 20px;

    .sections-bar {
      margin-top: 14px;
      margin-left: auto;
      margin-right: auto;

      .sections-header-container {
        display: flex;
        align-items: center;

        .sections-header {
          font-weight: 500;
          font-size: 14px;
          line-height: 26px;
        }

        .sections-count {
          font-size: 14px;
          line-height: 18px;
          opacity: 0.5;
          margin-left: 8px;
        }

        .add-section-btn {
          display: flex;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }

    .section-bar-sorting {
      .grid-section-category {
        &:hover {
          background: #fff !important;
          box-shadow: 0 22px 100px rgba(0, 0, 0, 0.09) !important;
          color: black !important;
        }
      }
    }

    .sections {
      display: flex;
      flex-wrap: wrap;
      margin: -5px;
    }

    .show-all-btn {
      position: absolute;
      right: -20px;
      top: 30px;
      cursor: pointer;
      z-index: 3;

      &:hover {
        path:first-child {
          fill: #a893f9;
        }

        path:last-child {
          fill: white;
        }
      }
    }

    .show-all-inverted {
      transform: rotate(180deg);
      margin-top: -4px;
    }

    .draggable-placeholder {
      border: 2px dashed #d3cce7;
      background: #f9f7ff;
      opacity: 0.5;
      height: 84px;
      margin: 5px;
      width: 188px;
      border-radius: 15px;
      display: none;
    }
  }

  .section-bar-hidden {
    transition: 0s all;
    visibility: hidden;
    opacity: 0;
    z-index: -1;
  }

  .sections-bar-sticky {
    position: sticky;
    z-index: 5 !important;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.04);
    margin-left: -90px;
    width: calc(100% + 180px);
    background: white;
  }

  .rec-object-sorting :global(.grid-section-category) {
    border: 2px dashed #d3cce7 !important;
    background: #f9f7ff !important;
    color: black !important;

    :global(.wc-count) {
      color: black !important;
      opacity: 0.5 !important;
    }

    &:hover {
      background: #896bd9 !important;
      color: white !important;
      border: 2px solid transparent !important;
      :global(.wc-count) {
        color: white !important;
      }

      :global(.editable-content) {
        &:hover {
          background: #896bd9 !important;
          cursor: pointer !important;
        }
      }
    }
  }

  .floating-action-bar-bottom {
    position: fixed;
    bottom: 40px;
    display: flex;
    align-items: center;
    z-index: 4;
    left: calc(50% - 32px);
  }

  .add-sections-tile {
    border: 1px solid #eae4ff;
    height: 102px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 188px;
    text-align: center;
    margin-bottom: 10px;

    &:hover {
      border-color: #a893f9;
      background-color: #eae4ff;
      cursor: pointer;
      > svg > path {
        fill: #a893f9;
      }
    }
  }
</style>

{#key refresh}
  <div
    class="grid-sections-bar"
    class:rec-object-sorting={recObjectSorting}
    class:sections-bar-sticky={sticky}
    class:section-bar-hidden={sticky && scrollDirection === 'down'}>
    <div
      class="sections-bar"
      style={`${hideSections ? 'display: none; ' : ''}${
        maxShown == 6 ? 'max-width: 1180px' : `max-width: ${196 * maxShown}px`
      }`}
      bind:this={sectionBarEl}>
      <div class="sections-header-container">
        <div class="sections-header">Sections</div>
        <div class="sections-count">{sections ? sections.length : 0}</div>

        {#if group.permissions.edit}
          {#if addingSection}
            <div
              style="display: flex; margin-left: 24px; align-items: center;
          font-size: 14px;">
              <span>
                <i class="fa fa-spinner fa-spin" style="color: #7054dc" />
              </span>
              <span style="margin-left: 8px; opacity: 0.5;">Adding section</span>
            </div>
          {:else if sections.length > 0}
            <div class="add-section-btn" on:click|preventDefault|stopPropagation={addSection}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12
              0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                  fill="#A893F9" />
                <path d="M16 12H8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 8V16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          {/if}
        {/if}
      </div>

      <div style="margin-top: 19px; position: relative;">
        {#if !recObjectSorting && sections.length > maxShown}
          <div
            class="show-all-btn"
            class:show-all-inverted={showAll}
            on:click|preventDefault|stopPropagation={() => {
              ComponentEvents.trigger('section-bar-keep-visibility', {
                fn: async function () {
                  showAll = !showAll;
                  computeSectionElHeight();
                },
              });
            }}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20
            0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                fill="#F8F6FF" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24.7592 18.3492C24.3998 17.9299 23.7685 17.8813 23.3492
            18.2407L20.5 20.6829L17.6508 18.2407C17.2314 17.8813 16.6001
            17.9299 16.2407 18.3492C15.8813 18.7685 15.9299 19.3998
            16.3492 19.7593L19.8492 22.7593C20.2237 23.0802 20.7763
            23.0802 21.1508 22.7593L24.6508 19.7593C25.0701 19.3998
            25.1187 18.7685 24.7592 18.3492Z"
                fill="#A893F9" />
            </svg>
          </div>
        {/if}

        <div
          use:setupSortable
          class="sections"
          on:mouseenter={() => {
            enableHoverDuringRecObjectDrag();
          }}
          on:mouseleave={() => {
            disableHoverDuringRecObjectDrag();
          }}>
          {#if sections.length == 0}
            <div
              style={'background: #f9f6ff;'}
              class="add-sections-tile"
              on:click|preventDefault|stopPropagation={addSection}>
              <div style="display: flex; flex-direction: column; align-items: center; padding: 16px;">
                <img alt="add-btn" src="/images/add-rec-btn.svg" width="24" height="24" />
                <div style="margin-top: 10px; font-weight: 400; font-size: 14px; line-height: 18px;  color: #a893f9;">
                  Add sections to <br /> organize your lists
                </div>
              </div>
            </div>
          {/if}
          {#each sections.sortBy((x) => x.position) as section, i (section.id)}
            {#if section && (showAll || sorting || (i >= shownStart && i < maxShown + shownStart))}
              <div data-section-bar-section-id={section.id}>
                <div class="draggable-placeholder">&nbsp;</div>
                <SectionTile
                  selectedSectionId={sticky ? selectedSectionId : undefined}
                  sectionId={section.id}
                  goToSection={goToSection} />
              </div>
            {/if}
          {/each}
        </div>
      </div>
    </div>

    {#if sticky && scrollDirection === 'up' && recObjectSorting !== true}
      <BackToTop style="position: fixed; top: {sectionBarElHeight + 106}px; z-index: 2" />
    {/if}
  </div>
{/key}
